import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function requestRoles(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_ROLES)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/roles',
      category: 'requestRoles',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestRoles')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getRolesSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestRolesFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestRoles')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getRolesFail(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/roles.js